var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 5.62175L6.175 0.498315C6.12969 0.459253 6.07188 0.437378 6.01094 0.437378H4.62813C4.5125 0.437378 4.45938 0.581128 4.54688 0.656128L10.0188 5.40613H0.875C0.80625 5.40613 0.75 5.46238 0.75 5.53113V6.46863C0.75 6.53738 0.80625 6.59363 0.875 6.59363H10.0172L4.54531 11.3436C4.45781 11.4202 4.51094 11.5624 4.62656 11.5624H6.05625C6.08594 11.5624 6.11563 11.5514 6.1375 11.5311L12.0781 6.378C12.1322 6.33097 12.1756 6.27287 12.2053 6.20764C12.235 6.14241 12.2504 6.07156 12.2504 5.99988C12.2504 5.9282 12.235 5.85735 12.2053 5.79212C12.1756 5.72689 12.1322 5.66879 12.0781 5.62175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.c47e9ef9429bb5887008bdfa1289bb56.svg";
export { ForwardRef as ReactComponent };